/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  index.tsx
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { Switch } from 'vant'
import { Component, Watch, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SSwitch extends Vue {
  @Prop() value!: boolean
  render () {
    const props = {
      ...this.$props
    }
    props.value = !!props.value
    return (
      <van-switch {...{ props: { ...props } }} value = {!!this.value}>
      </van-switch>
    )
  }
}
